import React from 'react';

import PropTypes from 'prop-types';

import clsx from 'clsx';

import {
    Button,
    Glyphicon,
    Image,
    ItemCard,
    Panel,
    SubHeading,
} from 'reaxl';
import { DelayedImpressionObserver, sendClick, sendImpressions } from 'reaxl-analytics';

import { treehouseAdCTAClick, treehouseImpression } from '@/analytics/treehouseAdEvents';

function TreehouseAdPlacement({ isXs = false, listing = {}, orientation = 'portrait' }) {

    const SRP_TREEHOUSE_AD_CONSTANTS = {
        HEADING: 'Drive home, plug in',
        DESCRIPTION: 'Treehouse makes it easy to install home charging so you\'re ready to go from day one.',
    };

    const VDP_TREEHOUSE_AD_CONSTANTS = {
        HEADING: 'Fully Charge Your EV Overnight',
        DESCRIPTION: 'Treehouse makes home charging installation easy.',
    };

    const imgSrc = `/cm-api/content/static/img/fba/treehouse/${listing?.vin ? 'vdp' : 'srp'}_treehouse${isXs ? '_xs' : ''}.png`;
    const adUrl = `https://pages.treehouse.pro/ford-blueadvantage${listing?.vin ? `?utm_source=vdp&vin=${listing?.vin}` : '?utm_source=srp'}`;

    const renderHeaderAndDescription = (
        <div className="padding-4">
            <SubHeading
                size={isXs ? 600 : 500} // keep size consistent for mobile heading
            >
                {listing?.vin ? VDP_TREEHOUSE_AD_CONSTANTS.HEADING : SRP_TREEHOUSE_AD_CONSTANTS.HEADING}
            </SubHeading>
            {listing?.vin ? VDP_TREEHOUSE_AD_CONSTANTS.DESCRIPTION : SRP_TREEHOUSE_AD_CONSTANTS.DESCRIPTION}
        </div>
    );

    const renderButton = (
        <div className="padding-4 display-flex justify-content-center">
            <Button
                bsStyle="secondary"
                block={orientation !== 'landscape'}
                href={adUrl}
                onClick={(e) => {
                    sendClick(treehouseAdCTAClick, e, { inventory: listing });
                }}
                role="button"
                target="_blank"
            >
                Get a Free Estimate
                <Glyphicon
                    glyph="offsite"
                    className="margin-left-1"
                />
            </Button>
        </div>
    );

    return (
        <DelayedImpressionObserver
            key="treehouse-ad-placement"
            onChange={() => {
                sendImpressions({ name: treehouseImpression, data: { inventory: listing } });
            }}
            delay={0}
            id="treehouse-ad-placement"
            className="display-flex"
        >
            <Panel
                data-cmp="treehouse-ad"
                className={clsx('display-flex w-100 padding-0', {
                    'flex-column': orientation !== 'landscape',
                })}
            >
                <ItemCard
                    sideBar={(
                        <Image
                            src={imgSrc}
                            alt="Treehouse Ad"
                            loading="eager"
                            className="img-responsive-scale"
                            style={{ height: '100%', objectFit: 'cover' }}
                        />
                    )}
                    orientation={orientation}
                    body={renderHeaderAndDescription}
                    footer={renderButton}
                />
            </Panel>
        </DelayedImpressionObserver>
    );
}

TreehouseAdPlacement.propTypes = {
    isXs: PropTypes.bool,
    listing: PropTypes.object,
    orientation: PropTypes.oneOf(['landscape', 'portrait']),
};

export default TreehouseAdPlacement;
